import React from 'react';

const CustomTextArea = ({ label, value, onChange, placeholder = '', disabled = false, rows = 4, style = {}, width = '100%', height = 'auto', id, required = false, error = false, helperText = '', htmlRequired }) => {
  const inputHeight = height !== 'auto' ? height : '24px';
  const inputId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;
  const borderColor = error ? 'var(--color-error, #d32f2f)' : 'var(--color-border-input)';
  const effectiveRequired = htmlRequired === false
    ? false
    : Boolean(required || (typeof label === 'string' && label.includes('*')));
  return (
    <div style={{ width, ...style }}>
      {label && <label htmlFor={inputId} style={{ display: 'block', marginBottom: 4, color: 'var(--color-text)', fontWeight: 500, fontSize: '14px', textAlign: 'left', fontFamily: 'inherit' }}>{label}</label>}
      <textarea
        id={inputId}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={effectiveRequired}
        aria-label={label || placeholder}
        aria-required={effectiveRequired}
        aria-invalid={error}
        rows={height !== 'auto' ? undefined : rows}
        style={{
          width: '100%',
          height: height !== 'auto' ? inputHeight : undefined,
          padding: '8px 16px',
          borderRadius: '8px',
          border: `1px solid ${borderColor}`,
          background: 'var(--color-bg-input)',
          color: 'var(--color-text)',
          fontSize: '15px',
          fontFamily: 'inherit',
          fontWeight: 400,
          outline: 'none',
          opacity: disabled ? 0.6 : 1,
          resize: 'vertical',
          transition: 'border 0.2s',
          boxSizing: 'border-box',
        }}
        onFocus={e => (e.target.style.border = error ? '1.5px solid var(--color-error, #d32f2f)' : '1.5px solid var(--color-accent)')}
        onBlur={e => (e.target.style.border = `1px solid ${borderColor}`)}
      />
      {helperText && <div style={{ marginTop: 4, fontSize: '12px', color: 'var(--color-error, #d32f2f)' }}>{helperText}</div>}
    </div>
  );
};

export default CustomTextArea; 




